import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Helmet from 'react-helmet';

const SubRouter = ({ routes = [] }) => {
  return (
    <Routes>
      {routes.map(({ path = '', element, pageTitle }) => (
        <Route
          key={path}
          path={path}
          element={
            <>
              <Helmet>
                <title>
                  {pageTitle
                    ? `${pageTitle} | Suits Me Banking`
                    : 'Suits Me Banking'}
                </title>
              </Helmet>
              {element}
            </>
          }
        />
      ))}
    </Routes>
  );
};

export default SubRouter;
